import { Card, Col, Row } from "react-bootstrap";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import React from "react";
import { useNavigate } from "react-router-dom";

const SentApplicationsStatisticsList = ({ bundledSentApplications }) => {
  const navigate = useNavigate();
  const HandleGoToCandidate = (candidateId) => {
    navigate("/candidate", { state: { candidateId: candidateId, backUrl: "/dash" } });
  };

  return bundledSentApplications?.map((sentApplicationsBundle, i) => (
    <Card
      key={i}
      className={"mt-4 list-container text-20 fw-medium text-color-gray-dark"}
      style={{ backgroundColor: "white" }}
    >
      <Row className={"list-row "} style={{ borderBottomWidth: 0 }}>
        <Col
          xs={3}
          className={"align-content-center text-color-gray-light"}
          style={{ borderRight: "2px solid #e7ecef" }}
        >
          <Row className={"justify-content-center"}>{ParseDate(sentApplicationsBundle.date).date} </Row>
          <Row className={"justify-content-center"}>{ParseDate(sentApplicationsBundle.date).time}</Row>
        </Col>
        <Col>
          {sentApplicationsBundle.candidates?.map((candidate, index) => {
            const isLastItem = sentApplicationsBundle.candidates.length === index + 1;

            return (
              <Row key={index} style={{ borderBottom: `${isLastItem ? "0" : "2"}px solid #e7ecef` }}>
                <Col className={"align-content-center "} style={{ borderRight: "2px solid #e7ecef" }}>
                  <Row
                    onClick={() => HandleGoToCandidate(candidate.candidateId)}
                    className={"justify-content-center h-100 hover-bg-darken "}
                    style={{ paddingBottom: "10px", paddingTop: "10px", cursor: "pointer" }}
                  >
                    <Col xs={"auto"} className={"align-content-center"}>
                      {candidate.candidateName}
                    </Col>
                  </Row>
                </Col>
                <Col className={"align-content-center py-3"}>
                  {candidate.applications.map((applicationName, applicationIndex) => {
                    const isLastItem = candidate.applications.length === applicationIndex + 1;

                    return (
                      <Row key={applicationIndex} className={"justify-content-center"}>
                        <Col
                          xs={"auto"}
                          className={"align-content-center px-4"}
                          style={{ borderBottom: `${isLastItem ? "0" : "2"}px solid #e7ecef` }}
                        >
                          {applicationName}
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </Card>
  ));
};
export default SentApplicationsStatisticsList;
